import { tv } from "@/utils/tv.config";

import { VariantProps } from "tailwind-variants";

export const timelineItemSlotsClasses = tv({
  slots: {
    root: [
      "Timeline__item-root",
      "relative",
      "flex",
      "items-center",
      "justify-between",
      "md:justify-normal",
      "md:odd:flex-row-reverse",
      "group",
      // "is-active", //This can be applied conditionally
    ],
    icon: [
      "Timeline__item-icon",
      "flex",
      "items-center",
      "justify-center",
      "size-8",
      "rounded-full",
      "shadow",
      "shrink-0",
      "md:order-1",
      "md:group-odd:-translate-x-1/2",
      "md:group-even:translate-x-1/2",
      // "border-white",
      "bg-gray-200",
      "text-gray-700",
      // "group-[.is-active]:bg-indigo-100",
      // "group-[.is-active]:text-primary-main",
      // "counter-increment", //This can be applied conditionally
    ],
    card: [
      "Timeline__item-card",
      "w-[calc(100%-3rem)]",
      "md:w-[calc(50%-32px)]",
    ],
    content: [
      "flex",
      "items-center",
      "justify-between",
      "space-x-2",
      "md:group-even:flex-row-reverse",
    ],
    title: ["font-bold text-slate-900"],
    time: ["font-caveat", "font-medium", "text-primary-light"],
    description: ["text-slate-500", "md:group-even:text-right"],
  },
  variants: {
    orientation: {
      horizontal: "",
      vertical: "",
    },
    isNumeric: {
      true: {
        icon: ["counter-increment"],
        root: ["is-active"],
      },
    },
    isConnected: {
      true: {
        card: [
          "before:absolute",
          "before:w-6",
          "before:h-px",
          "before:bg-gray-200",
          "md:before:group-odd:-translate-x-1/2",
          "md:before:group-even:translate-x-1/2",
          "md:before:group-odd:left-1/2",
          "md:before:group-odd:ml-5",
          "md:before:group-even:right-1/2",
          "md:before:group-even:mr-5",
          "md:before:top-1/2",
          "md:before:-translate-y-1/2",
        ],
      },
    },
  },
});

export const {
  root: timelineItemClasses,
  icon: timelineItemIconClasses,
  card: timelineItemCardClasses,
  content: timelineItemContentBoxClasses,
  title: timelineItemTitleClasses,
  time: timelineItemTimeClasses,
  description: timelineItemDescriptionClasses,
} = timelineItemSlotsClasses();

export type TimelineVariantProps = VariantProps<typeof timelineItemClasses>;
